<!--
  Badge Component
  Variants: default, success, warning, error, info, accent
  Features: removable (with x button)
  Events: remove (X button; the click does not bubble to parent click handlers)
-->
<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher<{ remove: void }>();
  export let variant: 'default' | 'success' | 'warning' | 'error' | 'info' | 'accent' = 'default';
  export let removable = false;

  const variantClasses: Record<string, string> = {
    default: 'bg-surface-hover text-text-secondary border-border',
    success: 'bg-success/15 text-success border-success/30',
    warning: 'bg-warning/15 text-warning border-warning/30',
    error: 'bg-error/15 text-error border-error/30',
    info: 'bg-info/15 text-info border-info/30',
    accent: 'bg-accent-subtle text-accent border-accent/30',
  };
</script>

<span
  class="inline-flex items-center gap-1 px-2 h-6 text-xs font-medium uppercase rounded-full border whitespace-nowrap {variantClasses[
    variant
  ]}"
>
  <slot />
  {#if removable}
    <button
      type="button"
      class="ml-0.5 p-0 bg-transparent border-none cursor-pointer text-current opacity-60 hover:opacity-100 transition-opacity"
      on:click|stopPropagation={() => dispatch('remove')}
      aria-label="Remove"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>
    </button>
  {/if}
</span>
